// extracted by mini-css-extract-plugin
export default {"label":"TabCinque_label__wXqFV","labelDisabled":"TabCinque_labelDisabled__2+F3j","textFieldDisabled":"TabCinque_textFieldDisabled__3lIN+"};